export default __webpack_public_path__ + "assets/docs/EULA.def70c02.pdf";